<!-- 设备履历 -->
<style scoped="scoped" lang="scss"></style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/gelanda/mould/resume/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <template #buttonsL>
        <!-- 导入更新累计开合模次数       -->
        <el-button size="mini" v-if="utils.checkPower('custom_mold_resume_import_mould_times')" @click="yt.showEditDialog('daoru', null, 'w2')" plain>  {{$t('daoru')}}  </el-button>
      </template>

      <!-- 冻结列 保养次数 -->
      <template #baoyangcishu="scope">
        <el-button type="text" @click="yt.showEditDialog('baoyangcishu', scope.row, '70%')">
          {{ scope.row.maintainTimes }}
        </el-button>
      </template>
      <!-- 冻结列 维修次数 -->
      <template #weixiucishu="scope">
        <el-button type="text" @click="yt.showEditDialog('weixiucishu', scope.row, '70%')">
          {{ scope.row.repairTimes }}
        </el-button>
      </template>

    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action === 'daoru'">
        <div class="dialog-scroller">
          <yi_excel_import ref="gldMouldResumeImportRef" :templatekey="'gld_mould_resume_import'" :uploadApi="'/custom/gelanda/mould/config/batch/create'" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="default" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="importLoading" type="primary" size="mini" @click="importData">{{ $t('baocun') }}</el-button>
        </span>
      </template>
      <!-- 保养次数 -->
      <template v-if="yt.editObj.action == 'baoyangcishu'">
        <div class="dialog-scroller">
          <maintenance_times :maintenanceRecord="yt.editObj" ref="maintenanceRecord"></maintenance_times>
        </div>
      </template>
      <!-- 维修次数 -->
      <template v-if="yt.editObj.action == 'weixiucishu'">
        <div class="dialog-scroller">
          <repair_times :repairRecord="yt.editObj" ref="repairRecord"></repair_times>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import maintenance_times from './maintenance_times';
import repair_times from '@@/pages/web/mold_management/resume/repair_times';
export default {
  name: 'web_mold_management_resume_gld',
  components: {
    maintenance_times,
    repair_times,
  },

  data() {
    return {
      // orgList: [],
      list: [],
      importLoading: false,
      columns: [
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          fixed: 'left'
        },
        {
          label: 'mujubianma',
          prop: 'mould.code'
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name',
          fixed: 'left'
        },
        {
          label: 'mujuzhuangtai',
          prop: 'mould.status',
          type: 'dictionary_tag',
          key: 'BASIC_MOULD_STATUS'
        },
        {
          label: "mujuweizhi",
          prop: "mould.location"
        },
        {
          label: 'mujulurushijian',
          prop: 'insertTime',
          type: 'time'
        },
        {
          label: 'mujushouming',
          prop: 'life'
        },
        {
          label: '前期已使用寿命',
          prop: 'earlyUsedLifetime',
        },
        {
          label: 'yishiyongshouming',
          prop: 'totalClosingTimes',
        },
        {
          label: 'mujushengyushouming',
          prop: 'remainingLife'
        },
        {
          label: 'shangcibaoyangshijian',
          prop: 'lastMaintainTime',
          type: 'time'
          // format: "YYYY-MM-DD"
        },

        {
          label: 'baoyangcishu',
          type: 'slot',
          width: 80,
          fixed: 'right'
        },
        {
          label: 'weixiucishu',
          type: 'slot',
          width: 80,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.utils.event_hub.$on('MOLD_RESUME_MAINTENANCE_REFRESH', () => {
        this.yt.get();
      });
      this.yt.conditions = {
        orderBy: 'no asc'
      };
      this.yt.get(1);
    }, 300);
  },

  methods: {
    time(e) {
      if (e == 0) {
        return '';
      }
      let date = new Date(e);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? '0' + MM : MM;
      let d = date.getDate();
      d = d < 10 ? '0' + d : d;
      let h = date.getHours();
      h = h < 10 ? '0' + h : h;
      let m = date.getMinutes();
      m = m < 10 ? '0' + m : m;
      let s = date.getSeconds();
      s = s < 10 ? '0' + s : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    importData() {
      const data = [...this.$refs.gldMouldResumeImportRef.tableData];
      if (data.length <= 0) {
        this.$message.error(this.$t('qingshangchuanwenjian'));
        return;
      }
      this.importLoading = true;
      if (this.$refs.gldMouldResumeImportRef.listLength == null || this.$refs.gldMouldResumeImportRef.listLength.length == 0) {
        return this.http
          .post('/custom/gelanda/mould/config/batch/create?onlyValidate=false', data)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get(1);
          }).catch(error => {
            this.utils.errorMessage(error);
          }).finally(() => {
            this.importLoading = false;
          });
      } else {
        this.utils.errorMessage(this.$t('daoruxinxiyouwu'));
      }
    },
  }
};
</script>
